/**
 * @param {number} openingYear  //Page 2
 * @param {number} designYear //Page 2
 * @param {number} discountRate //Page 6
 * @returns {object} returns an object with the discount factor for each year starting from openingYear to designYear
 */
const getDiscountFactors = (openingYear, designYear, discountRate) => {
  const discountFactor = {};
  for (let year = openingYear; year <= designYear; year++) {
    discountFactor[year] = 1 / Math.pow(1 + discountRate, year - openingYear);
  }
  return discountFactor;
};

/**
 * Inputs
 * @param {number} openingYear  //Page 2
 * @param {number} designYear //Page 2
 * @param {number} discountRate //Page 6
 * @param {object} crashesPerYear = {
 * openingYear: {total: {number}, fatalInjury:{number}},
 * designYear: {total: {number}, fatalInjury:{number}}
 * } // Not Found
 * @param {object} crashTypeCosts = {
 * fatalInjury: {number},
 * propertyDamageOnly: {number}} * // Not Found
 * @returns {number} returns the safety cost value
 */
export const getSafetyCostsTotal = ({
  openingYear,
  designYear,
  discountRate,
  crashesPerYear,
  crashTypeCosts,
}) => {
  //  calculating PDO (Property Damage Only) based on total and fatal crashes
  crashesPerYear.openingYear.propertyDamageOnly =
    crashesPerYear.openingYear.total - crashesPerYear.openingYear.fatalInjury;
  crashesPerYear.designYear.propertyDamageOnly =
    crashesPerYear.designYear.total - crashesPerYear.designYear.fatalInjury;

  // Calculating crash costs
  const crashCosts = {
    openingYear:
      crashesPerYear.openingYear.fatalInjury * crashTypeCosts.fatalInjury +
      crashesPerYear.openingYear.propertyDamageOnly *
        crashTypeCosts.propertyDamageOnly,
    designYear:
      crashesPerYear.designYear.fatalInjury * crashTypeCosts.fatalInjury +
      crashesPerYear.designYear.propertyDamageOnly *
        crashTypeCosts.propertyDamageOnly,
  };

  const crashCostsYearly = {};
  // Calculating the cost for every year starting from openingYear to Design Year
  for (let year = openingYear; year <= designYear; year++) {
    if (year === openingYear) {
      crashCostsYearly[year] = crashCosts.openingYear;
    } else if (year === designYear) {
      crashCostsYearly[year] = crashCosts.designYear;
    } else if (crashCosts.openingYear > 0 && crashCosts.designYear > 0) {
      crashCostsYearly[year] =
        crashCosts.openingYear *
        Math.pow(
          crashCosts.designYear / crashCosts.openingYear,
          (year - openingYear) / (designYear - openingYear)
        );
    } else {
      throw new Error("Opening Year or Design Year less than or equal to 0");
    }
  }

  const discountFactorsYearly = getDiscountFactors(
    openingYear,
    designYear,
    discountRate
  );

  // calculates safety cost
  let safetyCostsTotal = 0;
  for (let year = openingYear; year <= designYear; year++) {
    safetyCostsTotal += discountFactorsYearly[year] * crashCostsYearly[year];
  }
  return safetyCostsTotal;
};
